import types from '@/actions/types';
import useContent from '@/composables/useContent';
import Base from '@/actions/base';
import useAnalytics from '@/composables/useAnalytics';

export default class QrReader extends Base {
  constructor(params) {
    super(params, types.QR_READER);
  }

  async execute() {
    const { resetCurrentContent, contentPromise } = useContent();
    const { trackAction } = useAnalytics();
    trackAction(this);

    // we need to wait for the previous slide to finish
    if (contentPromise.value) {
      await contentPromise.value;
    }

    resetCurrentContent();
    return new Promise((resolve) => {
      this.resolve = resolve;
    });
  }

  stop() {
    if (this.resolve) {
      this.resolve();
    }
  }
}
